import { render, staticRenderFns } from "./marketData_doc.vue?vue&type=template&id=24f7a862&scoped=true"
import script from "./marketData_doc.vue?vue&type=script&lang=js"
export * from "./marketData_doc.vue?vue&type=script&lang=js"
import style0 from "./marketData_doc.vue?vue&type=style&index=0&id=24f7a862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7a862",
  null
  
)

export default component.exports